import React, { useState, useCallback, useRef } from 'react'
import { allowErrorDialog } from '@/utils/fetch'
import context from '@/context'
import { BsrsGrid, Column, DateCell, DateFilterCell, LinkColumn } from '@/components/BsrsGrid'
import NameColumn from '@/components/BsrsGrid/BsrsGrid.NameColumn'
import { useLocalization } from '@/hooks/localization'
import { addBulkButtons, addCommandCell } from './commandCells'
import CheckBox from '@/components/CheckBox'
import { Col, Row } from 'reactstrap'
import moment from 'moment'

const AcceptedReportSubmissionGroupsGrid = (props) => {
  const [includeUnaccepted, setIncludeUnaccepted] = useState(false)
  const [outputReports, setOutputReports] = useState(false)
  const [gridKey, setGridKey] = useState(moment())
  const gridRef = useRef()
  const { localize, locale } = useLocalization()
  const { datasets, onReportSubmissionGroupAdd, onReportSubmissionGroupsBulkAdd, outputReportGroupDefinitionId } = props

  const inputReportsDataSource = useCallback((request) =>
    context.api.outputReportGroupService.getReportSubmissionGroupsForDatasets(outputReportGroupDefinitionId,
      includeUnaccepted,
      outputReports,
      request,
      allowErrorDialog), [outputReportGroupDefinitionId, includeUnaccepted, outputReports])

  const changeIncludeAccepted = useCallback(() => {
    setIncludeUnaccepted(!includeUnaccepted)
    setGridKey(moment())
  }, [includeUnaccepted])

  const changeOutputReports = useCallback(() => {
    setOutputReports(!outputReports)
    setGridKey(moment())
  }, [outputReports])

  const getFilteredData = useCallback(() => {
    return gridRef.current.getFilteredData() // Not pretty but it is better than the alternatives
  }, [])

  return (
    <React.Fragment>
      <Row className='accepted-submissions-header'>
        <Col sm='3'>
          <CheckBox title={'Reporting.IncludeUnaccepted'} checked={includeUnaccepted} onChange={changeIncludeAccepted} />
        </Col>
        <Col sm='3'>
          <CheckBox title={'Menu.OutputReports'} checked={outputReports} onChange={changeOutputReports} />
        </Col>
        <Col sm='1'>{localize('Reporting.BulkAddFiltered')}</Col>
        <Col sm='5'>{addBulkButtons({ localize, datasets, onReportSubmissionGroupsBulkAdd, getFilteredData })}</Col>
      </Row>

      <BsrsGrid ref={gridRef} dataSource={inputReportsDataSource} key={gridKey}>
        {NameColumn({ nameProp: 'institutionName', latinNameProp: 'institutionLatinName', locale, title: localize('Reporting.InstitutionName'), editable: false })}
        {NameColumn({ nameProp: 'reportGroupName', latinNameProp: 'reportGroupLatinName', locale, title: localize('Reporting.ReportingGroup'), editable: false })}
        <Column field='name' title={localize('Common.Name')} editable={false} />
        <Column field='latinName' title={localize('Common.LatinName')} editable={false} />
        <Column field='snapshotDate' title={localize('Reporting.SnapshotDate')} filter='date' cell={DateCell} filterCell={DateFilterCell} editable={false} />
        {LinkColumn({ urlFormatter: (dataItem) => `/report-submission-groups/${dataItem.reportSubmissionGroupId}/report-submissions`, linkText: localize('Common.Detail') })}
        <Column cell={addCommandCell({ localize, datasets, onReportSubmissionGroupAdd })} width='150px' filterable={false} editable={false} />
      </BsrsGrid>
    </React.Fragment>
  )
}

export {
  AcceptedReportSubmissionGroupsGrid
}



// WEBPACK FOOTER //
// ./src/internal-app/pages/outputReportGenerator/grids/acceptedReportSubmissionGroupsGrid.js